// @flow

import {flip, merge, map, prop, mapObjIndexed, groupBy} from 'ramda'
import {mergerActiveCount} from '../rules-helper'
import {prependRulesIndexerString} from './portfolios/util'
import moment from 'moment'
import {PortfolioNotificationEvent} from '../types'

export const toIdMapBy = (idName: string) => (companies: Array<any>) => {
  const obj = {}
  for (let i = 0; i < companies.length; i++) {
    const id = (companies: Array<any>)[i][idName]
    obj[id] = companies[i]
  }
  return obj
}

export const toSafeNumberIdMapBy = (idName: string) => (companies: Array<any>, portfolioId: number) => {
  const obj = {}
  if (portfolioId === 0) {
    for (let i = 0; i < companies.length; i++) {
      const id = (companies: Array<any>)[i][idName]
      const portfolioName = (companies: Array<any>)[i]['portfolioName']
      obj[`${portfolioName}_${id}`] = companies[i]
    }
  } else {
    for (let i = 0; i < companies.length; i++) {
      const id = (companies: Array<any>)[i][idName]
      obj[id] = companies[i]
    }
  }
  return obj
}

export const toIndexerMapBy = (id: string) => <T>(xs: Array<T>): {[string]: T} => {
  const obj = {}
  if (id === 'portfolioId') {
    const defaultIndexer = 'indexer' + 0
    obj[defaultIndexer] = {'portfolioId': 0, 'name': 'All Portfolios', 'isDefault': false, 'isAllPortfolio': true}
  }
  for (let i = 0; i < xs.length; i++) {
    const idValue = (xs: Array<any>)[i][id]
    const indexer = 'indexer' + idValue
    obj[indexer] = xs[i]
  }
  return obj
}

export const replace = flip(merge)

export const getStats = (data: Object) => {
  const {reason = '', successfulPortfoliosCompanies} = data
  let duplicateSafeNumbers = reason.match(/Duplicate\s*entry\s*'\s*\d+-[A-Z]{2}\d+\s*'/g)
  let failedSafeNumbers = reason.match(/'\s*\d+-[A-Z]{2}\d+\s*'/g)
  if (failedSafeNumbers) {
    failedSafeNumbers = map((safeNum) => extractSafeNumber(safeNum), failedSafeNumbers)
  }
  if (duplicateSafeNumbers) {
    duplicateSafeNumbers = (map((safeNum) => extractSafeNumber(safeNum), duplicateSafeNumbers)).sort()
  }
  return {
    successfulCompanies: successfulPortfoliosCompanies,
    duplicateSafeNumbers,
    failedSafeNumbers,
  }
}

const extractSafeNumber = (input: string) => {
  const quoteIndex = input.indexOf('\'')
  return input.substring(quoteIndex + 1, input.length - 1).trim()
}

export const getPermissionsPayload = (data: Object) => {
  let payload = {revokeAll: false, userPermissions: []}
  if (data.revokeAll) {
    payload.revokeAll = true
  } else {
    payload.userPermissions = data.users.map((user) => {
      return {userId: user.userId, permissions: user.permissions}
    })
  }
  return payload
}

export const mergePortfolios = (portfoliosObj: Object) => {
  const mergedPortfoliosObj = {}
  if (portfoliosObj.sharedPortfolios && portfoliosObj.sharedPortfolios.length > 0) {
    mergedPortfoliosObj['portfolios'] = [...portfoliosObj.portfolios, ...portfoliosObj.sharedPortfolios]
  } else {
    mergedPortfoliosObj['portfolios'] = [...portfoliosObj.portfolios]
  }
  return mergedPortfoliosObj
}

export const checkStateOfEventRules = (action: any, portfIndexer: any) => {
  let {change, country, groupId} = action
  const groupIndexer = prependRulesIndexerString('group', groupId)
  const ruleIndexer = prependRulesIndexerString('rule', change.ruleCode)
  let changePath = []
  let changeAllPath = []
  let inactiveCount = 0
  let checkPreviousCount = 0
  let totalCount = 0
  let index = 0
  if (change.val === 0) inactiveCount++ // increase inactive count when user un-checks any checkbox
  map((subRules) => {
    // create SubRule path to toggle the subRules 'isActive' values
    if ((change.subGroupName === subRules.name) || (change.subGroupName === '')) {
      changePath = [
        portfIndexer, 'rules', country, groupIndexer, 'subGroupRules', index, 'subGroupRules', ruleIndexer, change.prop,
      ]
    }
    map((r) => {
      if (mergerActiveCount(r.isActive, r.ruleCode)) {
        // Increase the count when merger rules are active (having 'isActive' 1)in previous state
        checkPreviousCount++
      } else if (r.isActive === 0) {
        // Increase the count when sub-rules are inactive (having 'isActive' 0) in previous State
        inactiveCount++
      }
    }, subRules.subGroupRules)
    index++
  }, change.subGroupAllRules)
  if (change.ruleCode !== 510) {
    if (mergerActiveCount(change.val, change.ruleCode)) {
      // calculate the change count by comparing updated active rules with previous active rules
      change.count = Math.abs(change.count - checkPreviousCount)
    }
  }
  totalCount = inactiveCount - change.count
  changeAllPath = [
    portfIndexer, 'rules', country, groupIndexer, 'notificationRules', ('rule' + 501), change.prop,
  ]
  let updateRulesState = {changePath, totalCount, changeAllPath, portfIndexer}
  return updateRulesState
}

const getEventDate = (key: string, activeLabel: string) => {
  const eventDate = moment(activeLabel).format('YYYY-MM-DDTHH:mm:ss')
  const date = eventDate.split('T')
  return key.includes(date[0])
}
export const getEvents = (notifications: Array<PortfolioNotificationEvent>, updateFilteredData: Function) => (mouse: any) => {
  let filteredData = []
  const groupByDate = groupBy(prop('eventDate'), notifications)
  mapObjIndexed((data, key) => {
    if (getEventDate(key, mouse.activeLabel)) {
      data.map((event) => filteredData.push(event))
    }
  }, groupByDate)
  updateFilteredData(filteredData)
}



// WEBPACK FOOTER //
// ./src/store/util.js